import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    themes: {
      light: {
        primary: '#003d58',
        primaryLight: '#e2eef6',
        accent: '#0089ba'
      }
    }
  }
})
/* SCSS HEX */
// $charleston-green: #0e2026ff;
// $columbia-blue: #cadde3ff;
// $alice-blue: #edf8fcff;
// $cerulean-crayola: #00a4dbff;
// $deep-saffron: #ff9933ff;
